import ProgressLoader from 'components/Loader/ProgressLoader';
import useQueriesRunningInBackGround from 'hooks/useQueriesRunningInBackGround';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { selectCustomMap } from 'store/selectors/customMapSelector';

export default function FileUploadLoader(){
	const { uploadingMapIds, uploadProgress } = useSelector(selectCustomMap);
	const { uuid } = useSelector((state: RootState) => state.roofData.data);
	
	const uploadQueryKey = `upload-custom-map-${uuid}`;
	const isUploadingFile = useQueriesRunningInBackGround([uploadQueryKey], 'mutating');
	const isUploading = isUploadingFile || !!uploadingMapIds?.length;
	const text = isUploadingFile ? 'Uploading...' : 'Loading...';

	return (
		<>
			{isUploading && <ProgressLoader text={'Uploading...'} progress={uploadProgress}/>}
		</>
	);
}